import { ChatbotWidget } from '../widgets/chatbot/index.type';
import { MessagesSquare } from 'lucide-react';

type AgentIntegrationChatbotButtonDesignProps = { widget: ChatbotWidget };

export const AgentIntegrationChatbotButtonDesign = ({
  widget,
}: AgentIntegrationChatbotButtonDesignProps) => {
  return (
    <div className="h-full w-full">
      <div className="flex items-center justify-between">
        <div className="h-6 w-2/3 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-6 w-1/4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
      </div>
      <div className="mt-6 grid gap-3">
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 w-2/3 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
      </div>
      <div className="mt-6 grid gap-3">
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 w-1/2 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 w-2/3 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
      </div>
      <div className="mt-6 grid gap-3">
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 w-1/2 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 w-2/3 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
      </div>
      <div className="mt-6 grid gap-3">
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
        <div className="h-4 w-2/3 rounded-sm bg-primary-100 dark:bg-secondary-200"></div>
      </div>

      <div
        className="absolute bottom-5 right-5 flex aspect-square w-14 items-center justify-center rounded-full bg-primary"
        style={{
          background: widget.designSettings['chat-toggle-button--background-color'],
        }}
      >
        <MessagesSquare
          style={{ color: widget.designSettings['chat-toggle-button--color'] }}
          className="aspect-square w-6 text-inherit text-white"
          width="25"
          height="25"
        />
      </div>
    </div>
  );
};
